// extracted by mini-css-extract-plugin
export var card = "_85-1";
export var container = "_85-0";